export class Tab {
    constructor(dataTab, activeHash = ''){
        if (dataTab === 'tabs'){
            const tab = document.querySelector(`[data-tab="${dataTab}"]`);
            if (tab){
                const { id } = tab.dataset;

                activeHash = id;
            }
        }


        this.config = {
            dataTab: dataTab,
            activeHash: activeHash,
            active: {
                tab: 'tab--active',
            }
        };

        let tabs = document.querySelectorAll(`[data-tab="${this.config.dataTab}"]`);
        if (!tabs.length){
            return;
        }

        this.defaultSettings();

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) =>{
                e.preventDefault();
                let dataset = tab.dataset.contentId;
                window.location.hash = dataset;

                this.hideTabContent();
                this.show(dataset);
                this.cleanTabsButton(tabs);
                tab.classList.add(this.config.active.tab);

                if (document.body.offsetWidth < 1324){
                    this.scrollTo(`[data-tab-content-id="${dataset}"]`, -30);
                }
            });
        });

    }

    hideTabContent() {
        let tabs = document.querySelectorAll(`[data-tab-id="${this.config.dataTab}"]`);
        tabs.forEach((tab) => {
            $(tab).hide();
        });
    }

    cleanTabsButton(tabs){
        tabs.forEach( (tab) => {
           tab.classList.remove('tab--active');
        });
    }

    defaultSettings(){
        this.show(this.hash());
        document.querySelector(`[data-id=${this.hash()}]`).classList.add(this.config.active.tab);
    }

    show(dataset){
        let id = `[data-tab-content-id="${dataset}"]`;
        $(id).fadeIn();
    }

    scrollTo(element, offset = 0){
        $([document.documentElement, document.body]).animate({
            scrollTop: $(element).offset().top + offset,
        },200);
    }

    hash(){
        let hash = window.location.hash.substr(1);

        return hash ? hash : this.config.activeHash;
    }
}